module.exports = __webpack_public_path__ + "static/medavie-provider-2-936a914c1f6337e2276987292953dd44.png";